import { Icon } from "@/components/Icon/Icon";

export function DiscoverPanel() {
  return (
    <div className="panel slide-up discover-panel">
      <div className="hstack" style={{ gap: 24, alignItems: "center" }}>
        <div className="discover-icon-tile">
          <Icon name="beaker" size={42} />
        </div>
        <div className="vstack gap-2" style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 16, fontWeight: 500 }}>
            A blank flask, ready when you are.
          </div>
          <div
            style={{
              fontSize: 13,
              color: "var(--ink-3)",
              lineHeight: 1.5,
              maxWidth: 560,
              textWrap: "pretty",
            }}
          >
            Add ingredients one at a time and feel out the flavor space. When a
            direction starts to land, pin a target — or pick one from the
            library — right from the workbench.
          </div>
          <div className="hstack" style={{ gap: 8, marginTop: 4, flexWrap: "wrap" }}>
            <span className="chip">
              <Icon name="flask" size={10} />
              Free formulation
            </span>
            <span className="chip">
              <Icon name="target" size={10} />
              Pin a target anytime
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
